




















import { Vue, Component, Prop, Ref } from 'vue-property-decorator';
import { SearchBoxSize } from './types/search-box-size';

@Component({
  name: 'BaseSearchBox',
  inheritAttrs: false,
})
export default class BaseSearchBox extends Vue {
  @Prop() value: string;
  @Prop({ default: false }) doFocus?: boolean;
  @Prop({ default: SearchBoxSize.Medium }) size: SearchBoxSize;
  @Prop() dataExternal?: string;
  @Ref('searchBox') searchBox: HTMLInputElement;

  get listeners(): Record<string, (event?) => any> {
    return {
      ...this.$listeners,
      input: event => {
        this.$emit('input', event.target.value);
      },
    };
  }

  focus() {
    this.searchBox.focus();
    this.searchBox.setSelectionRange(this.value.length, this.value.length);
  }

  blur() {
    this.searchBox.blur();
  }

  mounted() {
    if (this.doFocus) {
      this.focus();
    }
  }
}
